import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiService } from 'src/app/Services/api.service';

@Component({
    selector: 'app-datafeed',
    templateUrl: './datafeed.component.html',
    styleUrls: ['./datafeed.component.scss'],
    standalone: false
})
export class DataFeedComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;

  constructor(private apiService: ApiService, private parentRoute: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
    this.apiService.Get<any>("integrations/datafeeds/" + this.ModelId).then(result => {
      this.Model = result;
      this.StopLoading();
    });
  }

  getFeedTypeText(feedType: number): string {
    return feedType === 0 ? 'Space occupancy changes' : 'Region occupancy summary';
  }
  
  getFeedTargetText(target: string): string {
    if (target === 'kinesis') return 'AWS Kinesis';
    if (target === 'sftp') return 'SFTP';
    return target;
  }
  
  isKinesisTarget(): boolean {
    return this.Model?.DataFeedTarget === 'kinesis';
  }
  
  isSFTPTarget(): boolean {
    return this.Model?.DataFeedTarget === 'sftp';
  }
} 
